import { AxiosInstance } from 'axios';
import { IAccidentReportRepository } from '@/model/repository/manager/accident/AccidentReportRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): IAccidentReportRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
